import { EmbeddableContact } from './EmbeddableContact';
import { EmbeddableLocation } from './EmbeddableLocation';

export class TerminalInfo {
  originContact?: EmbeddableContact;
  originLocation?: EmbeddableLocation;
  destinationContact?: EmbeddableContact;
  destinationLocation?: EmbeddableLocation;
  message?: string;

  constructor(opts?: Partial<TerminalInfo>) {
    if (opts?.originContact != null) {
      this.originContact = new EmbeddableContact(opts.originContact);
    }
    if (opts?.originLocation != null) {
      this.originLocation = new EmbeddableLocation(opts.originLocation);
    }
    if (opts?.destinationContact != null) {
      this.destinationContact = new EmbeddableContact(opts.destinationContact);
    }
    if (opts?.destinationLocation != null) {
      this.destinationLocation = new EmbeddableLocation(
        opts.destinationLocation,
      );
    }
    if (opts?.message != null) {
      this.message = opts.message;
    }
  }
}
